export const DATE_FORMAT = {
  US_FORMAT: 'MM/DD/YYYY',
  EU_FORMAT: 'DD/MM/YYYY',
  US_FORMAT_DASH: 'MM-DD-YYYY',
  EU_FORMAT_DASH: 'DD-MM-YYYY',
  US_FORMAT_DOT: 'MM.DD.YYYY',
  EU_FORMAT_DOT: 'DD.MM.YYYY',
  US_LONG: 'MMMM DD, YYYY',
  EU_LONG: 'DD MMMM YYYY',
  WEEKDAY: 'ddd, MMM D, YYYY',
  NO_DAY_LONG: 'MMMM YYYY',
  MONTH: 'MMMM',
  YEAR: 'YYYY',
  DAY: 'DD',
  DAY_NAME: 'ddd',
};

export const DATE_WIDGET_TYPE = {
  TODAY: 'today',
  WEEK: 'week',
};

export const dateDefaultOptions = {
  name: 'Date Widget',
  type: DATE_WIDGET_TYPE.TODAY,
  language: 'sv',
  textFont: 'Poppins',
  textSize: 12,
  weekTextSize: 12,
  format: DATE_FORMAT.EU_FORMAT,
  fontColor: '#000000',
  backgroundColor: '#FFFFFF',
  highlightColor: '#E3003A',
  opacity: 100,
  textSeparation: 10,
};
